import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Modal } from '@reveni-io/reveni-ui'

import CarrierSelector from '@/common/components/CarrierSelector/CarrierSelector'
import DeliveryMethodTypeSelector from '@/common/components/DeliveryMethodTypeSelector/DeliveryMethodTypeSelector'
import RegionFilter from '@/common/components/RegionFilter/RegionFilter'

import { filterNames } from '../constants'
import FilterTypeSelector from './FilterTypeSelector/FilterTypeSelector'
import { filterTypes } from './constants'
import * as Styles from './styles'

const FiltersModal = ({ show, onClose, preselectedFilterType, filters, onChangeFilter, regions, source, carriers }) => {
  const { t } = useTranslation()
  const [filterType, setFilterType] = useState(preselectedFilterType || filterTypes[0]?.value)

  const [regionsSelected, setRegionsSelected] = useState(null)
  const [deliveryMethodSelected, setDeliveryMethodSelected] = useState(null)
  const [carrierServiceSelected, setCarrierServiceSelected] = useState(null)

  useEffect(() => {
    if (show) {
      if (preselectedFilterType) {
        setFilterType(preselectedFilterType)
      } else {
        setFilterType(filterTypes.filter(type => type.source === source)[0]?.value)
      }
      setRegionsSelected(filters?.region || null)
      setDeliveryMethodSelected(filters?.deliveryMethod || null)
      setCarrierServiceSelected(filters?.carrierService || null)
    }
  }, [filters, preselectedFilterType, show, source])

  const applyFilters = () => {
    if (filterType === filterNames.region && regionsSelected) {
      onChangeFilter(filterNames.region, regionsSelected)
    }

    if (filterType === filterNames.deliveryMethod && deliveryMethodSelected) {
      onChangeFilter(filterNames.deliveryMethod, deliveryMethodSelected)
    }

    if (filterType === filterNames.carrierService && carrierServiceSelected) {
      onChangeFilter(filterNames.carrierService, carrierServiceSelected)
    }

    onClose()
  }

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={preselectedFilterType ? t('Editar filtro') : t('Añadir filtro')}
      size="l"
      actions={
        <Styles.ActionsContainer>
          <Button onClick={onClose} variant="outlined">
            {t('Cancelar')}
          </Button>
          <Button onClick={applyFilters}>{preselectedFilterType ? t('Editar filtro') : t('Añadir filtro')}</Button>
        </Styles.ActionsContainer>
      }
    >
      <FilterTypeSelector
        value={filterType}
        onChange={value => setFilterType(value)}
        disabled={preselectedFilterType}
        source={source}
      />
      {filterType === filterNames.region && (
        <RegionFilter
          label={t('Origen')}
          value={regionsSelected}
          onChange={value => setRegionsSelected(value)}
          regions={regions}
        />
      )}
      {filterType === filterNames.deliveryMethod && (
        <DeliveryMethodTypeSelector
          value={deliveryMethodSelected}
          onChange={value => setDeliveryMethodSelected(value)}
        />
      )}
      {filterType === filterNames.carrierService && (
        <CarrierSelector
          value={carrierServiceSelected}
          onChange={value => setCarrierServiceSelected(value?.id)}
          carriers={carriers}
        />
      )}
    </Modal>
  )
}

export default FiltersModal
